import React, { ComponentType, PropsWithChildren } from 'react';

export const withWrapper = <P,>(Wrapper: ComponentType<PropsWithChildren<{}>>, Child: ComponentType<P>) => 
    (props: PropsWithChildren<P>) => <Wrapper><Child {...props}/>{props.children}</Wrapper>;